import { actions } from './actions'

const initialState = {
  transportistas: {
    data: [],
    loading: false,
    error: '',
  },
  transportistasComentarios: {
    data: [],
    loading: false,
    error: '',
  },
  transportistasVisibles: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function transportistasReducer(state = initialState, action) {
  switch (action.type) {
    case actions.TRANSPORTISTAS_LOAD_REQUESTED:
      return { ...state, transportistas: { ...state.transportistas, loading: true } }
    case actions.TRANSPORTISTAS_LOAD_SUCCEEDED:
      return {
        ...state,
        transportistas: { ...state.transportistas, data: action.payload, loading: false },
      }
    case actions.TRANSPORTISTAS_LOAD_FAILED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: action.error },
      }
    case actions.TRANSPORTISTAS_VACACIONES_LOAD_REQUESTED:
      return { ...state, transportistas: { ...state.transportistas, loading: true } }
    case actions.TRANSPORTISTAS_VACACIONES_LOAD_SUCCEEDED:
      return {
        ...state,
        transportistas: { ...state.transportistas, data: action.payload, loading: false },
      }
    case actions.TRANSPORTISTAS_VACACIONES_LOAD_FAILED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: action.error },
      }
    case actions.TRANSPORTISTA_BY_ID_LOAD_REQUESTED:
      return { ...state, transportistas: { ...state.transportistas, loading: true } }
    case actions.TRANSPORTISTA_BY_ID_LOAD_SUCCEEDED:
      return {
        ...state,
        transportistas: {
          ...state.transportistas,
          data: [
            ...state.transportistas.data?.filter(b => b.id !== action.payload?.id),
            action.payload,
          ].sort((a, b) => a.id - b.id),
          loading: false,
        },
      }
    case actions.TRANSPORTISTA_BY_ID_LOAD_FAILED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: action.error },
      }

    case actions.TRANSPORTISTAS_COMENTARIOS_LOAD_REQUESTED:
      return {
        ...state,
        transportistasComentarios: { ...state.transportistasComentarios, loading: true },
      }
    case actions.TRANSPORTISTAS_COMENTARIOS_LOAD_SUCCEEDED:
      return {
        ...state,
        transportistasComentarios: {
          ...state.transportistasComentarios,
          data: action.payload,
          loading: false,
        },
      }
    case actions.TRANSPORTISTAS_COMENTARIOS_LOAD_FAILED:
      return {
        ...state,
        transportistasComentarios: {
          ...state.transportistasComentarios,
          loading: false,
          error: action.error,
        },
      }

    case actions.TRANSPORTISTA_UPDATE_REQUESTED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_UPDATE_SUCCEEDED:
      return {
        ...state,
        transportistas: {
          ...state.transportistas,
          data: [
            ...state.transportistas.data?.filter(b => b.id !== action.payload?.id),
            action.payload,
          ].sort((a, b) => a.id - b.id),
          loading: false,
        },
      }
    case actions.TRANSPORTISTA_UPDATE_FAILED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: action.error },
      }
    case actions.TRANSPORTISTA_INSERT_REQUESTED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_INSERT_SUCCEEDED:
      return {
        ...state,
        transportistas: {
          ...state.transportistas,
          data: [].concat(action.payload, state.transportistas.data),
          loading: false,
          error: '',
        },
      }
    case actions.TRANSPORTISTA_INSERT_FAILED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: action.error },
      }
    case actions.TRANSPORTISTA_DELETE_REQUESTED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_DELETE_SUCCEEDED:
      return {
        ...state,
        transportistas: {
          ...state.transportistas,
          data: state.transportistas.data.filter(trad => trad.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.TRANSPORTISTA_DELETE_FAILED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: action.error },
      }
    case actions.TRANSPORTISTA_VACACIONES_INSERT_REQUESTED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_VACACIONES_INSERT_SUCCEEDED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: '' },
      }
    case actions.TRANSPORTISTA_VACACIONES_INSERT_FAILED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: action.error },
      }
    case actions.TRANSPORTISTA_VACACIONES_DELETE_REQUESTED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_VACACIONES_DELETE_SUCCEEDED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: '' },
      }
    case actions.TRANSPORTISTA_VACACIONES_DELETE_FAILED:
      return {
        ...state,
        transportistas: { ...state.transportistas, loading: false, error: action.error },
      }

    case actions.TRANSPORTISTA_COMENTARIOS_INSERT_REQUESTED:
      return {
        ...state,
        transportistasComentarios: { ...state.transportistasComentarios, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_COMENTARIOS_INSERT_SUCCEEDED:
      return {
        ...state,
        transportistasComentarios: {
          ...state.transportistasComentarios,
          data: [].concat(action.payload, state.transportistasComentarios.data),
          loading: false,
          error: '',
        },
      }
    case actions.TRANSPORTISTA_COMENTARIOS_INSERT_FAILED:
      return {
        ...state,
        transportistasComentarios: {
          ...state.transportistasComentarios,
          loading: false,
          error: action.error,
        },
      }
    case actions.TRANSPORTISTA_COMENTARIOS_ORDEN_UPDATED:
      return {
        ...state,
        transportistasComentarios: {
          ...state.transportistasComentarios,
          data: state.transportistasComentarios.data.map(comentario => {
            const cambio = action.payload.find(c => c.id === comentario.id)
            return cambio ? { ...comentario, orden: cambio.orden } : comentario
          }),
        },
      }
    case actions.TRANSPORTISTA_COMENTARIOS_DELETE_REQUESTED:
      return {
        ...state,
        transportistasComentarios: { ...state.transportistasComentarios, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_COMENTARIOS_DELETE_SUCCEEDED:
      return {
        ...state,
        transportistasComentarios: {
          ...state.transportistasComentarios,
          data: state.transportistasComentarios.data.filter(trad => trad.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.TRANSPORTISTA_COMENTARIOS_DELETE_FAILED:
      return {
        ...state,
        transportistasComentarios: {
          ...state.transportistasComentarios,
          loading: false,
          error: action.error,
        },
      }
    case actions.TRANSPORTISTAS_VISIBLES_LOAD_REQUESTED:
      return {
        ...state,
        transportistasVisibles: { ...state.transportistasVisibles, loading: true },
      }
    case actions.TRANSPORTISTAS_VISIBLES_LOAD_SUCCEEDED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          data: action.payload,
          loading: false,
        },
      }
    case actions.TRANSPORTISTAS_VISIBLES_LOAD_FAILED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          loading: false,
          error: action.error,
        },
      }
    case actions.TRANSPORTISTA_VISIBLES_INSERT_REQUESTED:
      return {
        ...state,
        transportistasVisibles: { ...state.transportistasVisibles, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_VISIBLES_INSERT_SUCCEEDED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          // El alta es un upsert: si el mensajero ya tenía fila ese día, la nueva la sustituye
          data: [].concat(
            action.payload,
            state.transportistasVisibles.data.filter(
              v => v.id !== action.payload.id && v.transportistaId !== action.payload.transportistaId,
            ),
          ),
          loading: false,
          error: '',
        },
      }
    case actions.TRANSPORTISTA_VISIBLES_INSERT_FAILED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          loading: false,
          error: action.error,
        },
      }
    case actions.TRANSPORTISTA_VISIBLES_DELETE_REQUESTED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          loading: true,
          error: '',
          actualizado: true,
        },
      }
    case actions.TRANSPORTISTA_VISIBLES_DELETE_SUCCEEDED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          data: state.transportistasVisibles.data.filter(trad => trad.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.TRANSPORTISTA_VISIBLES_DELETE_FAILED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          loading: false,
          error: action.error,
        },
      }

    case actions.TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_REQUESTED:
      return {
        ...state,
        transportistasVisibles: { ...state.transportistasVisibles, loading: true, error: '' },
      }
    case actions.TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_SUCCEEDED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          data: action.payload,
          loading: false,
        },
      }
    case actions.TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_FAILED:
      return {
        ...state,
        transportistasVisibles: {
          ...state.transportistasVisibles,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
